module.exports = __webpack_public_path__ + "img/1543103466.9f08cbe3.jpg";